import { layoutIs } from 'shared/javascripts/util/detection'
import { mobileBreakpoint } from 'shared/javascripts/util/mobile_breakpoint'
import smoothReveal from 'frontend/unpoly/javascripts/util/smooth_reveal'
import { trackElementInteraction } from 'frontend/shared/javascripts/util/analytics'
import type { SetQueryEventProps } from 'frontend/shared/javascripts/compilers/fill_slot_with_query'

up.compiler('[data-header-search]', (element, { url: baseUrl }: { url: string }) => {
  const navigationBlock = element.closest('.navigation--block')!
  const navigation = element.closest('.navigation')!
  const input = element.querySelector<HTMLInputElement>('.header-search--input')!
  const elementLayer = up.layer.current

  const preview = element.querySelector('.header-search--preview')!
  preview.classList.add('-empty')

  const previewContentClass = 'header-search--preview-content'
  up.render({ target: preview, content: `<div class="${previewContentClass}"></div>` })

  function onChange(query: string) {
    if (query && query.length > 2) {
      if (mobileBreakpoint.matches) {
        trackElementInteraction(element, 'search.query')
      }

      const params = up.Params.fromForm(element)
      const url = [baseUrl, params.toQuery()].join('?')

      showPreview()

      up.render({
        target: `.${previewContentClass}`,
        failTarget: `.${previewContentClass}`,
        url,
        abort: 'target',
        history: false,
      })
    } else {
      hidePreview()
    }
  }

  function showInput() {
    navigationBlock.classList.add('-show')
    navigation.classList.add('-search-shown')
    if (layoutIs('sticky')) {
      input.focus()
    } else {
      void smoothReveal('.header-search').then(() => {
        input.focus()
      })
    }
  }

  function hideInput() {
    input.value = ''
    input.blur()
    navigationBlock.classList.remove('-show')
    navigation.classList.remove('-search-shown')
    hidePreview()
  }

  function showPreview() {
    preview.classList.remove('-empty')
  }

  function hidePreview() {
    preview.classList.add('-empty')
    up.render({ target: `.${previewContentClass}`, content: '', layer: elementLayer }) // when the search field is cleared, remove any previous preview results
  }

  function onSetQuery(event: Event & SetQueryEventProps) {
    input.value = event.query
  }

  function onFocus() {
    onChange(input.value)

    if (mobileBreakpoint.matches) {
      trackElementInteraction(element, 'click.element')
    }
  }

  function onResultLinkFollow(_event: Event, link: HTMLAnchorElement) {
    if (mobileBreakpoint.matches) {
      trackElementInteraction(link, 'click.headerSearchResult')
    }
  }

  function onNavigate() {
    if (input.matches(':focus')) input.blur()
    input.value = ''
    hidePreview()
    hideInput()
  }

  function onBodyClick(event: MouseEvent) {
    if ((event.target as Element).closest('[data-header-search-toggle]')) return
    if (!element.contains(event.target as Element)) hideInput()
  }

  function onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      hideInput()
    }
  }

  input.addEventListener('focus', onFocus)
  up.watch(element, { delay: 300 }, onChange)

  up.on('app.headerSearch.show', showInput)
  up.on('app.headerSearch.setQuery', onSetQuery as (e: Event) => void)
  up.on('up:location:changed', onNavigate)
  up.on('click touchstart', onBodyClick)
  up.on('keydown', onKeyDown)
  up.on(element, 'up:link:follow', `.${previewContentClass} a`, onResultLinkFollow)

  return () => {
    up.off('app.headerSearch.show', showInput)
    up.off('app.headerSearch.setQuery', onSetQuery)
    up.off('up:location:changed', onNavigate)
    up.off('click touchstart', onBodyClick)
    up.off('keydown', onKeyDown)
    up.off(element, 'up:link:follow', `.${previewContentClass} a`, onResultLinkFollow)
  }
})
